// La nouvelle interface, épurée (9 octobre 2026) : les soirées et le registre.
// Les textes que l'écran classique avait déjà (grilles, audiences, calibration)
// restent lus dans `projector.soirees` et `projector.commun`.
export default {
  titre: 'Soirées',
  sousTitre: 'La soirée projetée la veille, scellée, puis confrontée à l’audience publiée',
  vues: 'Les vues des soirées',
  projeter: 'Projeter une soirée',
  scores: {
    aria: 'Le tableau des scores',
    scellees: 'projections scellées',
    confrontees: 'confrontées au réel',
    ecart: 'écart moyen avec l’audience, {cible}',
    brut: 'brut : {v} pts',
    fourchette: 'dans la fourchette projetée',
    aVenir: 'à venir',
  },
  registre: {
    dansLaFourchette: 'dans la fourchette projetée',
    horsFourchette: 'hors de la fourchette projetée',
  },
  vide: {
    titre: 'Votre registre est vide',
    texte: 'Chaque projection est scellée avant la diffusion : personne ne peut la retoucher après coup. C’est ce registre qui prouve, soirée après soirée, ce que valent les projections.',
    etapes: {
      choisir: {
        titre: 'Choisir la soirée',
        texte: 'La grille de la soirée est relevée : chaque chaîne, chaque programme en face du vôtre.',
      },
      sceller: {
        titre: 'Projeter et sceller',
        texte: 'La veille, les jumeaux passent la soirée devant la télévision ; la part d’audience projetée est scellée.',
      },
      confronter: {
        titre: 'Confronter',
        texte: 'Le lendemain, l’audience publiée arrive : l’écart s’inscrit au registre, sans retouche possible.',
      },
    },
  },
  soirees: {
    nouvelle: 'Une nouvelle soirée',
    jour: 'Jour',
    creneau: 'Créneau',
    relevees: 'Les soirées relevées',
    choisir: 'Choisissez une soirée relevée, ou relevez la grille d’une nouvelle : chaque programme en face du vôtre, puis « Projeter son audience ».',
    actions: 'Actions',
  },
}
